import React from "react"
import Img from "gatsby-image"

const Testimonials = ({ dataImage }) => {
  return (
    <React.Fragment>
      <div className="container">
        <h2 className="text-center ">Words From The People</h2>
        <p className="text-muted text-center lead mt-3">
          Because real humans said these nice things about me
        </p>
        <div className="row">
          {dataImage.map(testimony => {
            return (
              <div key={testimony.node.id} className="col-12 col-md-4">
                <div
                  className="p-3 rounded"
                  style={{ backgroundColor: `#fff` }}
                >
                  <Img
                    style={{ height: `20rem`, width: `auto` }}
                    fluid={testimony.node.childImageSharp.fluid}
                  />
                  <h3 className="pt-3">{testimony.node.name}</h3>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </React.Fragment>
  )
}
export default Testimonials
